import UserCentralProvider from '@/services/user.central.provider'
import RegisProvider from '@/services/registration.provider'
import Vue from 'vue'

const userCentralService = new UserCentralProvider()
const regisService = new RegisProvider()

const initialState = {
    is_authen: null,
    is_error: false,
    is_officer: false,
    is_authorized_officer: false,
    is_future_innovation_student: false,
    user_info: null,
    surrogated_student_id: null,
    surrogated_student_info: null,
};

export const user = {
    namespaced: true,
    state: initialState,
    actions: {
        async getUserInfo() {
            const response = await userCentralService.getAuthUserInfo()
                .catch((error) => {
                    this.state.user.is_error = true;
                    Vue.toasted.error(
                        JSON.stringify(error.response.data.message),
                        { duration: 0 }
                    )
                    if (error.response.data.message === 'Expired token') { // Token Expired
                        sessionStorage.clear();
                        window.location.reload();
                    }
                });

            if (response) {
                const acl_authorized_officer = [40, 45, 91];
                const acl_officer = [0, 10, 15, 18, 19, 22, 23, 25, 30, 35, 36, 40, 41, 45, 55, 60, 91];
                const acl_student = [80, 85];

                // เช็ค privilege ว่าสามารถใช้งานระบบได้
                if (
                    !acl_student.includes(response.payload.ticket.privilege) &&
                    !acl_officer.includes(response.payload.ticket.privilege) &&
                    !acl_authorized_officer.includes(response.payload.ticket.privilege)
                ) {
                    this.state.user.is_error = true;
                    Vue.toasted.error(
                        'ไม่มีสิทธิ์ใช้งานระบบ / Unauthorized',
                        { duration: 0 }
                    );
                    return;
                }

                // สิทธิ์เจ้าหน้าที่ทะเบียนฯ
                if (acl_authorized_officer.includes(response.payload.ticket.privilege))
                    this.state.user.is_authorized_officer = true

                // สิทธิ์เจ้าหน้าที่
                if (acl_officer.includes(response.payload.ticket.privilege))
                    this.state.user.is_officer = true

                // สิทธิ์นักศึกษา
                if (acl_student.includes(response.payload.ticket.privilege)) {
                    this.state.user.surrogated_student_id = response.payload.ticket.user_id
                } else {
                    this.state.user.surrogated_student_id = sessionStorage.getItem('surrogated_student_id');
                }

                // ถ้าเป็นนักศึกษา หรือสวมสิทธิ์ ให้ดึงข้อมูลนักศึกษา
                if (this.state.user.surrogated_student_id) {
                    const response2 = await userCentralService.getAuthUserInfo(this.state.user.surrogated_student_id)
                        .catch((error) => {
                            sessionStorage.removeItem('surrogated_student_id');
                            Vue.toasted.error(
                                JSON.stringify(error.response.data.message),
                                { duration: 0 }
                            )
                        });
                    if (response2) {
                        this.state.user.surrogated_student_info = response2;

                        // เช็คว่าเป็นนักศึกษา 4+1
                        const response3 = await regisService.isFutureInnovationStudent(this.state.user.surrogated_student_id);
                        if (response3 && response3.status)
                            this.state.user.is_future_innovation_student = true
                    } else
                        this.state.user.surrogated_student_info = null;
                }

                this.state.user.user_info = response;
                this.state.user.is_authen = true;
            } else
                this.state.user = initialState;
        },
        async logout({ dispatch }) {
            sessionStorage.clear();
            dispatch('keycloak/logout', null, { root: true });
            //router.go(0).catch(() => { }); # router.go bug not reload on safari browser
            // window.location.reload();
        },
        async logoutSurrogatedStudent() {
            sessionStorage.removeItem('surrogated_student_id');
            //router.go(0).catch(() => { }); # router.go bug not reload on safari browser
            window.location.reload();
        },
    },
    mutations: {
        setIsAuthen(state, is_authen) {
            state.is_authen = is_authen;
        }
    },
};
